module.exports = __webpack_public_path__ + "img/quickfact-placeholder.6a37e0e8.png";